export const rapid120180 = newValues => {
  //País manda: la norma metrológica (país) define la familia del conector.
  //USA -> CCS1/NACS ; europeo (Francia/Alemania/Resto) -> CCS2. Se preserva el tier (200/250 baja, 400/380 alta).
  const CCS2_A_USA = { CCS2_250_A: "CCS1_200_A", CCS2_380_A: "CCS1_400_A" }
  const USA_A_CCS2 = {
    CCS1_200_A: "CCS2_250_A",
    CCS1_400_A: "CCS2_380_A",
    NACS_250_A: "CCS2_250_A",
    NACS_380_A: "CCS2_380_A",
  }
  const paisEsUsa = newValues.EV_VATIMETRO === "USA"
  const rFront = newValues.EV_TIPO_CONECTOR_RIGHT_FRONT
  if (paisEsUsa && rFront && rFront.includes("CCS2")) {
    newValues.EV_TIPO_CONECTOR_RIGHT_FRONT = CCS2_A_USA[rFront] || "CCS1_200_A"
  } else if (
    !paisEsUsa &&
    rFront &&
    (rFront.includes("CCS1") || rFront.includes("NACS"))
  ) {
    newValues.EV_TIPO_CONECTOR_RIGHT_FRONT = USA_A_CCS2[rFront] || "CCS2_250_A"
  }

  //Conectores
  if (newValues.EV_NUM_CONECTORES === "120180_ONE") {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = ""
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = ""
  }

  if (newValues.EV_NUM_CONECTORES === "120180_ONE_PLUS") {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = ""
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = "AC_22"
    if (!newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("CCS2")) {
      newValues.EV_TIPO_CONECTOR_RIGHT_FRONT = "CCS2_250_A"
    }
  }

  if (newValues.EV_NUM_CONECTORES === "120180_DUO") {
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = ""
    if(newValues.EV_TIPO_CONECTOR_LEFT_FRONT === "") {
      newValues.EV_TIPO_CONECTOR_LEFT_FRONT = newValues.EV_TIPO_CONECTOR_RIGHT_FRONT
    }
  }

  if (newValues.EV_NUM_CONECTORES === "120180_TRIO") {
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = "AC_22"
    if (!newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("CCS2")) {
      newValues.EV_TIPO_CONECTOR_RIGHT_FRONT = "CCS2_250_A"
    }
    if (!newValues.EV_TIPO_CONECTOR_LEFT_FRONT.includes("CCS2")) {
      newValues.EV_TIPO_CONECTOR_LEFT_FRONT =
        newValues.EV_TIPO_CONECTOR_RIGHT_FRONT
    }
  }

  if (
    newValues.EV_NUM_CONECTORES === "120180_DUO" &&
    (newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("CCS1") ||
      newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("NACS")) &&
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT.includes("CCS2")
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT =
      newValues.EV_TIPO_CONECTOR_RIGHT_FRONT
  }

  if (
    newValues.EV_NUM_CONECTORES === "120180_DUO" &&
    newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("CCS2") &&
    (newValues.EV_TIPO_CONECTOR_LEFT_FRONT.includes("CCS1") ||
      newValues.EV_TIPO_CONECTOR_LEFT_FRONT.includes("NACS"))
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT =
      newValues.EV_TIPO_CONECTOR_RIGHT_FRONT
  }

  //Mangueras
  if (
    [
      "CCS1_400_A",
      "CCS2_250_A",
      "CCS2_380_A",
      "NACS_250_A",
      "NACS_380_A",
    ].includes(newValues.EV_TIPO_CONECTOR_LEFT_FRONT) &&
    newValues.EV_GESTION_MANGUERA === "POLEAS"
  ) {
    newValues.EV_LONGITUD_MANGUERA = ""
  }

  if (
    [
      "CCS1_400_A",
      "CCS2_250_A",
      "CCS2_380_A",
      "NACS_250_A",
      "NACS_380_A",
    ].includes(newValues.EV_TIPO_CONECTOR_RIGHT_FRONT) &&
    newValues.EV_GESTION_MANGUERA === "POLEAS"
  ) {
    newValues.EV_LONGITUD_MANGUERA = ""
  }

  //#9: con conectores de 380/400 A (CCS1_400_A, CCS2_380_A, NACS_380_A) solo se
  //deshabilita "Sistema de poleas y contrapesos"; BRAZOS y SIN siguen elegibles.
  //Si la selección actual era POLEAS (ya no válida), se pasa a BRAZOS.
  const CONECTORES_380_400 = ["CCS1_400_A", "CCS2_380_A", "NACS_380_A"]
  const front380400 =
    CONECTORES_380_400.includes(newValues.EV_TIPO_CONECTOR_LEFT_FRONT) ||
    CONECTORES_380_400.includes(newValues.EV_TIPO_CONECTOR_RIGHT_FRONT)

  if (front380400 && newValues.EV_GESTION_MANGUERA === "POLEAS") {
    newValues.EV_GESTION_MANGUERA = "BRAZOS"
  }

  if(newValues.EV_GESTION_MANGUERA !== "" && newValues.EV_GESTION_MANGUERA !== "SIN"){
    newValues.EV_LONGITUD_MANGUERA = ""
  }

  if(newValues.EV_GESTION_MANGUERA === "SIN" && newValues.EV_LONGITUD_MANGUERA === ""){
    newValues.EV_LONGITUD_MANGUERA = "3_5"
  }

  //#25: con CCS1/NACS de menor potencia (CCS1_200_A, NACS_250_A) y sin sistema de
  //gestión, la única longitud disponible es 6,5 m (STANDARD). Los de 380 A se rigen
  //por el brazo retráctil obligatorio (#9), que fija la longitud.
  const USA_250 = ["CCS1_200_A", "NACS_250_A"]
  const frontUsa250 =
    USA_250.includes(newValues.EV_TIPO_CONECTOR_LEFT_FRONT) ||
    USA_250.includes(newValues.EV_TIPO_CONECTOR_RIGHT_FRONT)
  if (
    frontUsa250 &&
    newValues.EV_GESTION_MANGUERA === "SIN" &&
    newValues.EV_LONGITUD_MANGUERA !== "STANDARD"
  ) {
    newValues.EV_LONGITUD_MANGUERA = "STANDARD"
  }

  //Guarda: ONE+ y TRIO solo admiten CCS2 (europeo). Si el conector acabó en CCS2
  //pero el país seguía en USA, el país pasa a europeo para mantener coherencia.
  if (
    newValues.EV_VATIMETRO === "USA" &&
    newValues.EV_TIPO_CONECTOR_RIGHT_FRONT &&
    newValues.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("CCS2")
  ) {
    newValues.EV_VATIMETRO = "FRANCIA"
  }

  return newValues
}
